import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom";
import { C, FONT } from "./accountStyles";



const crumbSx = {
  fontFamily: FONT,
  fontSize: '0.75rem',
  fontWeight: 700,
  letterSpacing: '2px',
  textTransform: 'uppercase',
};

export default function BasicBreadcrumbs(props) {
    const navigate = useNavigate();

    const handlePage = (e,value) => {
        navigate('/room')
    }

  return (
    <div >
      <Breadcrumbs aria-label="breadcrumb" separator="/" sx={{ '& .MuiBreadcrumbs-separator': { color: C.secondary } }}>
        <Link
          component="button"
          type="button"
          onClick={(e) => handlePage()}
          underline="hover"
          sx={{ ...crumbSx, color: C.secondary, minHeight: 40, py: 1, '&:hover': { color: C.ink } }}
        >
          My Account
        </Link>
        <Typography aria-current="page" sx={{ ...crumbSx, color: C.ink }}>{props.title}</Typography>
      </Breadcrumbs>
    </div>
  );
}
